module.exports = __webpack_public_path__ + "static/media/camry.bd195668.png";